import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Funcție reutilizabilă pentru verificarea sesiunii
  const checkSession = async () => {
    const token = localStorage.getItem("token");
  
    if (!token) {
      console.warn("⚠️ Fără token. Utilizator delogat.");
      setUser(null);
      setLoading(false);
      return;
    }
  
    // 🚫 Dacă nu ești online, nu are sens să încerci requestul
    if (!navigator.onLine) {
      console.warn("⛔ Offline - asteptam reconectarea pentru verificarea sesiunii");
      setLoading(true); // Păstrăm loading până revine netul
      return;
    }
  
    try {
      const response = await fetch("https://tj.marenergy.ro/api/session.php", {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const data = await response.json();
        
      if (response.ok) {
        setUser(data.user);
      } else {
        setUser(null);
      }
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false); // doar dacă am avut rețea
    }
  };  

  // 🔹 Verificare sesiune la reîncărcare pagină
  useEffect(() => {
    checkSession();
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      checkSession(); // re-verifică când revii online
    };
  
    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, []);  

  // 🔹 Login (API Call)
  const login = async (email, password) => {
    try {
      const response = await fetch("https://tj.marenergy.ro/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Dacă loginul declanșează 2FA, nu avem încă token
        return data;
      } else {
        throw new Error(data.message || "Autentificare eșuată");
      }
    } catch (error) {
      throw new Error("Conexiune eșuată. Încearcă din nou.");
    }
  };

  // Nouă funcție pentru finalizarea loginului după 2FA
  const completeLogin = (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, completeLogin, logout, loading, checkSession }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;